import moment from 'moment'
import { server } from '@/services/'
import transformJson from '@/utils/transformJson'

const state = {
  searchForm: {}
}

const mutations = {
  SET_SEARCH_FORM: (state, payload) => {
    state.searchForm = payload
  },
  RESET_SEARCH_FORM: (state) => {
    state.searchForm = {}
  }
}

const actions = {
  getReservations(_, payload) {
    return new Promise((resolve, reject) => {
      if (Object.keys(payload).length < 1) {
        payload.reservationStart = moment().format('YYYY-MM-DD 00:00')
        payload.reservationEnd = moment().format('YYYY-MM-DD 23:59')
      }
      server.post('/proxy/cocos/getReservationsBySearch', payload)
        .then((res) => {
          resolve(res.data.msgContent.data)
        })
        .catch((err) => reject(err))
    })
  },
  setImmobilizer(_, payload) {
    return new Promise((resolve, reject) => {
      server.post('/proxy/cocos/setBlockUnblockImmobilizer', payload)
        .then((res) => {
          resolve(res.data)
        })
        .catch((err) => reject(err))
    })
  },
  getFleetEvents(_, payload) {
    return new Promise((resolve, reject) => {
      server.post('/proxy/cocos/getFleetEvents', payload)
        .then((res) => {
          resolve(res.data.msgContent.data)
        })
        .catch((err) => reject(err))
    })
  },
  getCars (_, payload) {
    return new Promise((resolve, reject) => {
      server.post('/proxy/cocos/getCars', payload).then(
        resp => {
          resolve(transformJson(resp.data.msgContent.data, true))
        },
        err => reject(err)
      )
    })
  },
  lockUnlockCar (_, payload) {
    return new Promise((resolve, reject) => {
      server.post('/proxy/cocos/setLockVehicle', payload).then(
        resp => {
          resolve(resp.data)
        },
        err => {
          reject(err)
        }
      )
    })
  },
  getCurrentPosition(_, payload) {
    return new Promise((resolve, reject) => {
      server.post('/proxy/cocos/requestCurrentPosition', payload)
        .then((resp) => {
          resolve(resp.data)
        })
    })
  },
  revokeReservation(_, payload) {
    return new Promise((resolve, reject) => {
      server.post('/proxy/cocos/cancelReservation', payload).then((resp) => {
        resolve(resp.data)
      }).catch((err) => reject(err))
    })
  },
  retransmitReservation(_, payload) {
    return new Promise((resolve, reject) => {
      server.post('/proxy/cocos/retransmitReservation', payload).then((resp) => {
        resolve(resp.data)
      }).catch((err) => reject(err))
    })
  }
}

const getters = {

}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}